import { apiClient } from '@/services/api';
import type { EarningsListResponse } from '@/types/earning';

export interface EarningsListParams {
  page?: number;
  perPage?: number;
}

export const earningsService = {
  /**
   * GET /api/v1/earnings — paginated history for the current user.
   * Server clamps page to [1, 100_000] and per_page to [1, 100], and
   * computes `meta.has_more` from `(page * per_page) < total_count`.
   * No client-side clamping — let the server own the bounds so they
   * stay in one place.
   */
  async list(params: EarningsListParams = {}): Promise<EarningsListResponse> {
    const query = new URLSearchParams();
    if (params.page !== undefined) query.set('page', String(params.page));
    if (params.perPage !== undefined) query.set('per_page', String(params.perPage));
    const suffix = query.toString();
    const path = suffix ? `/api/v1/earnings?${suffix}` : '/api/v1/earnings';
    return apiClient.get<EarningsListResponse>(path);
  },
};
